// extracted by mini-css-extract-plugin
export default {"list":"yPGxsTx7","whats-next":"dBij8mDL","whatsNext":"dBij8mDL","title":"GRs_tmcH","subtitle":"cRlXd3ft","button-container":"uWkYEfUh","buttonContainer":"uWkYEfUh"};